import getFactorClient from "./getFactorClient";

const getFreezeMeta = state => {
  const client = getFactorClient(state) || {};
  return {
    at: client.factored_receivables_frozen_at || null,
    by: client.factored_receivables_frozen_by || null,
    reason: client.factored_receivables_frozen_reason || null,
    scope: client.factored_receivables_frozen_scope || null
  };
};

export default getFreezeMeta;
